import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { CellContext } from '@tanstack/react-table';

export interface EmspBoChargingSessionListEmspUserLastNameCellProps
  extends CellContext<
    GatewayChargingSessionModel,
    GatewayChargingSessionModel['emspUser']['lastName']
  > {}

export const EmspBoChargingSessionListEmspUserLastNameCell = (
  props: EmspBoChargingSessionListEmspUserLastNameCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue() ?? '-'}</Text>;
};
